import React from 'react';
import {
  Card, Grid, Typography,
} from '@mui/material';
import { useTranslation } from '@gamiphy/react-i18n';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import CashbackIcon from '@gamiphy/icons/CashbackIcon';

export type Props = {
  currentCashBack: number,
}

const CashbackMission: React.FC<Props> = ({ currentCashBack }) => {
  const { t } = useTranslation();

  return (
    <Card sx={(theme) => ({ boxShadow: 'none', width: '100%', pb: theme.spacing(2) })}>
      <Grid
        container
        direction="row"
        alignItems="center"
        wrap="nowrap"
        columnSpacing={1}
      >
        <Grid>
          <CashbackIcon width="24px" height="24px" textColor={ThemeStore.theme?.palette?.primary?.main} />
        </Grid>
        <Grid>
          <Typography sx={{ fontSize: '1.2rem', fontWeight: 500, lineHeight: 1.25 }}>
            {t('mission.cashback.description', {
              defaultValue: 'Make a purchase and get {{currentCashBack}}% back in points',
              currentCashBack,
            })}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
};

export default CashbackMission;
